module.exports = __webpack_public_path__ + "img/ic_shalou.9fda7e0b.svg";